/* eslint-disable @typescript-eslint/no-explicit-any */ //REMOVE THIS BEFORE PR MERGE
import brandShortName from './collaborators/brand-short-name';
import channel from './collaborators/channel';
import pageName from './collaborators/page-name';
import pageType from './collaborators/page-type';
import brIUID from './collaborators/br-iuid';
import relatedRID from './collaborators/related-rid';
import { getPreFacetEngagement } from './collaborators/pre-facet-engagement';
import { CategoryPageAttributes } from './types';
import { AppProps } from 'src/app/App';

export default (props: AppProps): CategoryPageAttributes => {
  const { categoryName, businessUnitId, subcategoryName, params } = props;

  const attributes: CategoryPageAttributes = {
    brand_short_name: brandShortName(props),
    browse_refine_type: [],
    browse_refine_value: [],
    business_unit_id: businessUnitId,
    category_name: categoryName,
    channel: channel(props),
    page_name: pageName(props),
    page_type: pageType(props),
    br_iuid: brIUID(props),
    br_related_rid: relatedRID(props),
  };

  if (subcategoryName) {
    attributes.subcategory_name = subcategoryName;
  }

  const preFacetEngagement = getPreFacetEngagement(categoryName, params);

  if (preFacetEngagement) {
    attributes.pre_facet_engagement = preFacetEngagement;
  }

  return attributes;
};
